import React, { Component } from "react";
import { Form, Button, Image, Card, Alert } from "react-bootstrap";
import axios from "axios";
import CommonToast from "../Toaster/CommonToast";

export default class UserIdsUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userIds: [],
      uploading: false,
      previewUrls: [],
      displayUploadedIds: [],
      successMessage: '',
      uploadingStatus: '',
      completed: '',
      hasError: "",
      showToast: false,
      toastMessage: '',
      toastVariant: '',
      color: '',
    };
  }

  handleUserIdsChange = (event) => {
    this.setState({ userIds: Array.from(event.target.files) });
  };



  componentDidMount() {
    const { userId } = this.props;
    this.fetchEmployeeIdsUploaded(userId)
  }

  fetchEmployeeIdsUploaded = (id) => {
    axios({
      method: 'get',
      url: `document/documents/${id}/i`,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    })
      .then(res => {
        console.log("res data is here ", res);
        this.setState({ displayUploadedIds: res.data.documents })
      })
      .catch(err => {
        console.log("error is here", err)
      })
  }

  uploadUserIds = async () => {
    const { userId } = this.props;
    const { userIds } = this.state;
    if (!userId || userIds.length === 0) return;

    try {
      this.setState({ uploading: true });
      for (const userIdFile of userIds) {
        const formData = new FormData();
        formData.append("document", userIdFile);
        formData.append("type", "i");
        const res = await axios.post(`document/upload/id/${userId}`, formData);
        console.log("res?.data?.message===========>", res?.data?.message);
        this.setState({
          uploadingStatus: res?.data?.message,
          completed: true,
          toastMessage: res?.data?.message,
          toastVariant: 'success',
          color: 'green',
          showToast: true,
        })
      }
      this.fetchEmployeeIdsUploaded(userId)
    } catch (error) {
      this.setState({
        uploadingStatus: "Profile Image Upload Failed",
        hasError: true,
        toastMessage: "Profile Image Upload Failed",
        toastVariant: 'danger',
        color: 'red',
        showToast: true,
      })
    } finally {
      this.setState({ uploading: false });
    }
  };


  deleteIdsImage = (docId, index) => {
    const { userId } = this.props;
    axios({
      method: 'delete',
      url: `document/documents/${userId}/${docId}`,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    })
      .then((response) => {
        const updatedDocuments = [...this.state.displayUploadedIds];
        updatedDocuments.splice(index, 1);
        this.setState({
          displayUploadedIds: updatedDocuments,
          uploadingStatus: response.data.message,
          toastMessage: response.data.message,
          toastVariant: 'success',
          color: 'green',
          showToast: true,
        });
        // setTimeout(() => this.setState({ uploadingStatus: "" }), 3000);
      })
      .catch(err => {
        this.setState({
          toastMessage: "Error deleting document!",
          toastVariant: 'danger',
          color: 'red',
          showToast: true,
        });
        setTimeout(() => {
          this.setState({ showToast: false });
        }, 900);
        console.error("Error deleting document:", err);
      });
  }

  render() {
    return (
      <>
        <CommonToast
          show={this.state.showToast}
          onClose={() => this.setState({ showToast: false })}
          message={this.state.toastMessage}
          variant={this.state.toastVariant}
          color={this.state.color}
        />

        <div className="row">
          {/* {this.state.hasError ? (
            <Alert variant="outline-danger" className="m-3" block>
              {this.state.uploadingStatus}
            </Alert>
          ) : this.state.completed ? (
            <Alert variant="outline-success" className="m-3" block>
              {this.state.uploadingStatus}
            </Alert>
          ) : (
            <></>
          )} */}
        </div>
        <Card className="mb-3">
          {this.state.successMessage && (
            <div className="alert alert-success">
              {this.state.successMessage}
            </div>
          )}
          <Card.Body>
            <Form.Group>
              <Form.Label>Upload ID Documents</Form.Label>
              <Form.Control type="file" multiple accept=".pdf,.doc,.docx,.jpg,.png" onChange={this.handleUserIdsChange} />
              <Button variant='primary' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button btn btn-primary mt-2" onClick={this.uploadUserIds} disabled={this.state.uploading}>
                {this.state.uploading ? "Uploading..." : "Upload User IDs"}
              </Button>
            </Form.Group>
          </Card.Body >
          <table className="image-table">
            <thead>
              <tr>
                <th>Image/Pdf</th>
                <th>Actions</th>
              </tr>
            </thead>


            <tbody>
              {this.state.displayUploadedIds && this.state.displayUploadedIds.length > 0 ? (
                this.state.displayUploadedIds.map((doc, index) => {
                  const filePath = doc?.documentPath?.toLowerCase();
                  const isPdf = filePath?.endsWith(".pdf");
                  const isImage = /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(filePath);
                  const isDocx = filePath?.endsWith(".docx") || filePath?.endsWith(".doc");
                  const isTxt = filePath?.endsWith(".txt");

                  return (
                    <tr key={index}>
                      <td>
                        {isPdf ? (
                          <a
                            href={`${process.env.REACT_APP_BACKEND_URL}/${doc.documentPath}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <Button variant="outline-info" size="sm">📄 View PDF</Button>
                          </a>
                        ) : isImage ? (
                          <img
                            src={`${process.env.REACT_APP_BACKEND_URL}/${doc.documentPath}`}
                            alt={`Uploaded ${index}`}
                            className="document-image"
                            style={{ width: "100px", height: "auto" }}
                          />
                        ) : isDocx ? (
                          <a
                            href={`${process.env.REACT_APP_BACKEND_URL}/${doc.documentPath}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            download
                          >
                            <Button variant="outline-primary" size="sm">📑 Download DOCX</Button>
                          </a>
                        ) : isTxt ? (
                          <a
                            href={`${process.env.REACT_APP_BACKEND_URL}/${doc.documentPath}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            download
                          >
                            <Button variant="outline-secondary" size="sm">📄 Download TXT</Button>
                          </a>
                        ) : (
                          <span>Unsupported File Format</span>
                        )}
                      </td>
                      <td>
                        <Button
                          size="sm"
                          onClick={() => this.deleteIdsImage(doc.id, index)}
                          variant="outline-danger"
                        >
                          <i className="fas fa-trash"></i>
                        </Button>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="2">No documents available to display.</td>
                </tr>
              )}
            </tbody>
            {/* <tbody>
            {this.state.displayUploadedIds && this.state.displayUploadedIds.length > 0 ? (
              this.state.displayUploadedIds.map((doc, index) => (
                <tr key={index}>
                  <td>
                    <img src={doc?.documentPath} alt={`Uploaded ${index}`} className="document-image" />
                  </td>
                  <td>
                    <Button size="sm" onClick={() => this.deleteIdsImage(doc?.id, index)} variant="outline-danger">
                      <i className="fas fa-trash"></i>
                    </Button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="2">No images available to display.</td>
              </tr>
            )}
          </tbody> */}
          </table>
        </Card >
      </>
    );
  }
}
